import { render, staticRenderFns } from "./gen.vue?vue&type=template&id=c6ec40a0&scoped=true&"
import script from "./gen.vue?vue&type=script&lang=js&"
export * from "./gen.vue?vue&type=script&lang=js&"
import style0 from "./gen.vue?vue&type=style&index=0&id=c6ec40a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ec40a0",
  null
  
)

export default component.exports